<template>
  <!-- 업체정보 정정신청 -->
  <div>
    <v-card class="ma-4 word_keeper" >
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold">
          <v-icon class="mr-2">mdi-account-supervisor-circle-outline</v-icon>업체정보 정정 신청
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="mr-4 ml-4"></v-divider>
      <v-toolbar dense flat color="white" class="text-truncate">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          협력업체 기본정보
        </v-card-subtitle>
        <div class="ml-2 text-caption grey--text text--darken-2 font-weight-bold hidden-sm-and-down">
          <div>*사업자번호 변동이 없을시에만 업체정보 변경 신청이 가능합니다.</div>
          <div class="mt-n1">*업체정보 변경시 사업자 등록증은 필히 첨부 바랍니다</div>
        </div>
      </v-toolbar>
      <v-card-text class="hidden-md-and-up pb-0 pt-0 text-caption grey--text text--darken-2 font-weight-bold text-justify">
        <div>*사업자번호 변동이 없을시에만 업체정보 변경 신청이 가능합니다.</div>
        <div class="mt-n1">*업체정보 변경시 사업자 등록증은 필히 첨부 바랍니다</div>
      </v-card-text>


      <!-- 협력업체 기본정보 입력 레이아웃 -->
      <v-card outlined tile class="ma-4 mt-0">
        <v-card-text class="pt-6 pb-0">
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cBizCode" label="사업자 등록번호" dense disabled persistent-placeholder></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined tile class="ma-4 essetial_card">
        <v-card-text class="pt-6">
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cCorpNmKor" dense persistent-placeholder>
                <template v-slot:label>
                  <div>회사명(한글)<strong class="red--text" v-if="editedItem.cLocal == 'Y'">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cCorpNmEng" dense persistent-placeholder>
                <template v-slot:label>
                  <div>회사명(영문)<strong class="red--text" v-if="editedItem.cLocal == 'N'">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cCEO" dense persistent-placeholder>
                <template v-slot:label>
                  <div>대표자명<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cTel" dense persistent-placeholder type="number">
                <template v-slot:label>
                  <div>대표전화번호<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cFax" dense persistent-placeholder label="대표팩스번호" hint="[ 숫자만 입력 ]" type="number"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-if="editedItem.cLocal == 'Y'" v-model="editedItem.cZip" @click:append-outer="bDialogPost = true;" append-outer-icon="search" dense readonly persistent-placeholder>
                <template v-slot:label>
                  <div>우편번호<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
              <v-text-field v-else v-model="editedItem.cZip" label="우편번호" dense readonly persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cHomePage" dense persistent-placeholder label="홈페이지" :hint="'ex) ' + HomepageURL"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-if="editedItem.cLocal == 'Y'" v-model="editedItem.cAddr1" label="기본주소" disabled dense persistent-placeholder></v-text-field>
              <v-text-field v-else v-model="editedItem.cAddr1" dense persistent-placeholder>
                <template v-slot:label>
                  <div>기본주소<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="editedItem.cAddr2" dense persistent-placeholder>
                <template v-slot:label>
                  <div>상세주소<strong class="red--text" v-if="editedItem.cLocal == 'Y'">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-card flat tile class="ma-0 essetial_card" width="100%">
                <v-textarea
                  v-model="editedItem.cWork"
                  height="100"
                  class="rounded-0"
                  dense
                  no-resize
                  outlined
                  hide-details
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <div>{{$store.state.CustomInfo.SiteNm}} 관련 주요업무<strong class="red--text">*</strong></div>
                  </template>
                </v-textarea>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card flat tile class="ma-0 essetial_card" width="100%">
                <v-textarea
                  v-model="editedItem.cChangeReason"
                  label="변경 사유*"
                  height="100"
                  class="rounded-0"
                  dense
                  no-resize
                  outlined
                  hide-details
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <div>변경 사유<strong class="red--text">*</strong></div>
                  </template>
                </v-textarea>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>


      <v-divider class="mr-4 ml-4"></v-divider>
      <v-toolbar dense flat color="white" >
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          협력업체 관리자(정) 정보
        </v-card-subtitle>
        <v-spacer></v-spacer>
        <!-- <v-btn @click="ShowManagerDialog()" class="font-weight-bold" small dark width="70px">
          <v-icon small class="mr-1">mdi-plus</v-icon><div class="text-caption">추가</div>
        </v-btn> -->
      </v-toolbar>

      <v-card-text class="pt-0" >
        <v-row>
          <v-col cols="12">
            <v-data-table
              :items="CorMChargeInfo"
              :headers="headers"
              :hide-default-footer="true"

            >
              <template v-slot:item.cEdit="{ item }">
                <v-btn v-if="item.cCustomId == CustomInfo.CustomId" @click="ShowDelDialog(item)" icon><v-icon>delete</v-icon></v-btn>
              </template>
              <template v-slot:no-data>
                <div class="black--text">등록된 관리자(정) 이 존재하지 않습니다.</div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="mr-4 ml-4"></v-divider>
      <v-toolbar dense flat color="white">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          협력업체 관리자(부) 정보
        </v-card-subtitle>
        <v-spacer></v-spacer>
        <!-- <v-btn @click="ShowManagerDialog()" class="font-weight-bold" small dark width="70px">
          <v-icon small class="mr-1">mdi-plus</v-icon><div class="text-caption">추가</div>
        </v-btn> -->
      </v-toolbar>
      <v-card-text class="pt-0">
        <v-row>
          <v-col cols="12">
            <v-data-table
              :items="CorSChargeInfo"
              :headers="headers"
              :hide-default-footer="true"
            >
              <template v-slot:item.cEdit="{ item }">
                <v-btn v-if="item.cCustomId == CustomInfo.CustomId" @click="ShowDelDialog(item)" icon><v-icon>delete</v-icon></v-btn>
              </template>
              <template v-slot:no-data>
                <div class="black--text">등록된 관리자(부) 가 존재하지 않습니다.</div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>


      <!-- 사업자등록증 -->
      <v-divider class="mr-4 ml-4"></v-divider>
      <v-toolbar dense flat color="white">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          사업자등록증 등록
        </v-card-subtitle>
      </v-toolbar>
      <v-card-text>
        <v-card class="d-flex flex-wrap essetial_card" flat outlined tile>
          <v-card width="170" flat class="ml-4 mr-4 pa-4 essetial_card">
            <v-img
              :aspect-ratio="2/1"
              :src="sNowPath"
              contain
              style="height:100px"
              max-height="150px"
            ></v-img>
            <v-file-input
              v-on:change="onSelFile(NowSelFile)"
              v-model="NowSelFile"
              class="mt-2"
              accept="image/png"
              placeholder="파일선택"
              dense
            ></v-file-input>
          </v-card>
          <v-card class="essetial_card" flat>
            <v-card-subtitle class="grey--text text--darken-2 font-weight-bold pb-1">
              <p>사업자등록증<span class="red--text">*</span></p>
            </v-card-subtitle>
            <v-card-text class="text-caption">
              JPG,JPEG,PNG,GIF파일만 첨부하세요.<br>
              다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
              (첨부 할 수 있는 파일의 최대 크기는 10MB 까지 입니다)
            </v-card-text>
          </v-card>
        </v-card>
      </v-card-text>
      <v-card-text align="center">
        <v-divider class="ma-4"></v-divider>
        <v-btn @click="$router.push({name: 'MainBoard'});" width="100px" text class="mr-2"><v-icon class="mr-2">mdi-close</v-icon>취소</v-btn>
        <v-btn @click="SetCorpLog()" width="100px" dark class="ml-2"><v-icon class="mr-2">post_add</v-icon>신청</v-btn>
      </v-card-text>
    </v-card>


    <!-- 우편번호 찾기 다이올로그 창 -->
    <v-dialog v-model="bDialogPost"  max-width="500">              
      <template>
        <vue-daum-postcode @complete="oncomplete" />
      </template>
    </v-dialog>


    <!-- 관리자 삭제 확인 다이올로그 창 -->
    <v-dialog v-model="dialog" max-width="400">
      <v-card flat>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="grey--text text--darken-2 font-weight-bold" style="min-width:140px;">
            관리자 직에서 사임하시겠습니까?
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-card-text class="pa-4 pb-0">
          삭제 후 관리자 업무를 수행하실 경우 다시 신청 해 주셔야 합니다.
        </v-card-text>
        <v-card-actions class="pb-3 pr-4">
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false;" width="100px" text class="mr-2"><v-icon class="mr-2">mdi-close</v-icon>취소</v-btn>
          <v-btn @click="DelManager()" width="100px" dark class="ml-2"><v-icon class="mr-2">mdi-check</v-icon>삭제</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>


    <!-- <ChargeDialog ref="ChargeDialogRef" @SetManager="SetManager"/> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';
import Util from "../Util.js";

// import ChargeDialog from "../components/ChargeDialog.vue";

export default {
  components:{
    // ChargeDialog,
  },
  data: () => ({
    NowSelFile : null,
    bDialogPost : false,
    loading : false,
    iDelIndex : -1,
    dialog : false,
    sNowPath : "",
    // cJibunAddress : "",
    // cRoadAddress : "",
    editedItem: {
      cAddr1 : "",/* 기본주소 */
      cAddr2 : "",/* 상세주소 */
      cBizCode : "",/* 사업자 등록 번호 */
      cCorpNmEng : "",/* 회사이름 영문 */
      cCorpNmKor : "",/* 회사이름 한글 */
      cFax : "",/* 팩스 번호 */
      cHomePage : "",/* 홈페이지 주소 */
      cLocal : "",/* 국내 / 해외 */
      cCEO : "",/* 국내 / 해외 */
      cTel : "",/* 국내 / 해외 */
      cZip : "",/* 우편번호 */
      cWork : "",/* 주요업무 */
      cChangeReason : "",
      cFileId : "",
      cPath : "",
    },
    // DelChargeInfo : {
    //   cCustomId : "",
    //   cCustomNm : "",
    //   cEmail : "",
    // },
    headers : [
      { text: '관리자 이메일', value: 'cEmail' },
      { text: '이름', value: 'cCustomNm' },
      { text: '휴대전화번호', value: 'cTel' },
      { text: '대표전화번호', value: 'cPresentTel' },
      { text: '삭제', value: 'cEdit' },
    ],
    CorMChargeInfo : [],
    CorSChargeInfo : [],
  }),

  computed: {  
    ...mapState(["CustomInfo","HomepageURL","zFileType","FMaxSize3"]),
  },

  created() {
  },

  mounted() {
    // this.GetCorpInfo();
    this.GetCorpInformation();
  },

  methods : {
    // 관리자 열기 다이올로그창
    // ShowManagerDialog(){
    //   this.$refs.ChargeDialogRef.ShowDialog(2)
    // },

    // // 관리자 열기 다이올로그창에서 관리자 선택시
    // SetManager(data){
    //   let AddObject = {
    //     cCustomId : data[0].cCustomId,
    //     cCustomNm : data[0].cCustomNm,
    //     cEmail : data[0].cEmail,
    //     cPresentTel : data[0].cPresentTel,
    //     cTel : data[0].cTel,
    //   };
    //   this.CorMChargeInfo.push(AddObject)
    // },

    // 업체 관리자 정보 가져오기
    GetCorpInformation(){
      this.CorMChargeInfo = []
      this.CorSChargeInfo = []
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        //CorpId : this.CustomInfo.CorpId,
      };
      axios
        .post(process.env.VUE_APP_UIL_API + "GetCorpInformation", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }

          if (res.data.ResultCd == "04") { 
            
            EventBus.$emit("onRoute","MainBoard"); 
            
            setTimeout(() => {
              EventBus.$emit("onShowMsg",true, "관리자 권한이 없습니다.");               
            }, 100);



            return; 
          }
          if (res.data.ResultCd === "00") {
            if (res.data.Result1.length > 0) {
              res.data.Result1[0].cChangeReason = ""
              this.editedItem = res.data.Result1[0]
              this.sNowPath = process.env.VUE_APP_FILE_API + res.data.Result1[0].cPath
            }

            for (let k = 0; k < res.data.Result2.length;k ++) {
              if (res.data.Result2[k].cManager == "M") {
                this.CorMChargeInfo.push(res.data.Result2[k]);
              } else {
                this.CorSChargeInfo.push(res.data.Result2[k]);
              }
            }
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    // 우편번호찾기완료 (다이올로그로 찾기완료시)
    oncomplete: function(result){
      this.editedItem.cZip = result.zonecode;
      this.editedItem.cAddr2 = "";

      if(result.userSelectedType === 'R'){  // 도로명 주소 선택
        this.editedItem.cAddr1 = result.roadAddress
        this.iPostType = true
      } else {  // 지번 주소 선택
        this.editedItem.cAddr1 = result.jibunAddress
        this.iPostType = false
      }
      this.bDialogPost = false
    },

    // 삭제확인 다이올로그창 열기(데이터테이블 사용시)
    ShowDelDialog(item){
      // let DelIndex = this.CorChargeInfo.indexOf(item)
      // let DelIndex = this.CorSChargeInfo.indexOf(item)
      this.dialog = true;
      this.iDelIndex = this.CorSChargeInfo.indexOf(item);
      // this.DelChargeInfo.cCustomId = item.cCustomId
      // this.DelChargeInfo.cCustomNm = item.cCustomNm
      // this.DelChargeInfo.cEmail = item.cEmail
      // this.DelChargeInfo.bInsert = item.bInsert
    },

    // 파일 선택시 파일 경로 및 데이터 가져오기
    onSelFile(NowSelFile) {
      let bFileType = false

      if (NowSelFile != null)  {
        if (NowSelFile.size > this.FMaxSize3)  {
          this.sNowPath = process.env.VUE_APP_FILE_API + this.editedItem.cPath

          setTimeout(() => {
            this.NowSelFile = null;
          }, 300);
          EventBus.$emit("onShowMsgBox","첨부하신 파일의 용량의 크기를 확인하여 주세요.","첨부하실수 있는 파일의 크기는 최대 10MB 까지 입니다.");
          return
        }

        for ( let i in this.zFileType) {
          if (this.zFileType[i] == NowSelFile.type) {
            bFileType =  true;
            break
          }
        }
      } else {
        bFileType = true
      }

      if (!bFileType) {
        setTimeout(() => {
          this.NowSelFile = null;
        }, 300);
        EventBus.$emit("onShowMsgBox","첨부하신 파일의 형식을 확인하여 주세요.","첨부하실수 있는 파일의 형식은 JPG,JPEG,PNG,GIF 입니다.");
        return
      }

      this.loading = true
      const reader = new FileReader

      reader.onload = e => {
        var imageData = e.target.result;
        this.sNowPath = imageData;
        this.loading = false;
      }
      try {
        this.loading = false;
        reader.readAsDataURL(NowSelFile)
      }
      catch (error) {
        this.sNowPath = process.env.VUE_APP_FILE_API + this.editedItem.cPath
        this.loading = false;
        EventBus.$emit("onFileBus", true,""+error);
        // EventBus.$emit("onShowMsg", true,""+error);
      }
    },

    // 파일 저장하기
    bSendSvrFile(){
      var d = new Date();
      var Year = d.getFullYear(); 
      
      var fileName = this.NowSelFile.name;
      var Extend = Util.getExtension(fileName).toUpperCase();
      var sFileTypeId = Util.sGetId(Util.sGetFileType(this.NowSelFile.type));
        
      let formData = new FormData();
      formData.append('uploadfile', this.NowSelFile);
      return new Promise((resolve) => (
        axios.post(process.env.VUE_APP_UIL_API + "UploadFile?PublicFile=Y&Year="+Year+"&FileNm="+fileName+"&Extend="+Extend+"&MimeType="+this.NowSelFile.type+"&Size="+this.NowSelFile.size+"&FileTypeId="+sFileTypeId+"&SiteId="+this.$store.state.CustomInfo.SiteId,
                formData,
                {
                headers: {
                  // "Authorization" : this.CustomInfo.Token,
                  'Content-Type' : 'multipart/form-data',
                }
              }
            )
            .then(res => {
              resolve(res);
            })
            .catch(err =>{
              resolve(null);
              EventBus.$emit("onShowMsg",true, "파일저장에 실패하였습니다. 관리자에게 문의 바랍니다." + err)
          })
      ));
    },

    // 변경 신청하기
    async SetCorpLog() {
      if (this.editedItem.cLocal == "Y"){
        if (this.editedItem.cCorpNmKor == ""){
          EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "회사명(한글) 항목을 확인 하세요.");
          return
        }
        if (this.editedItem.cCEO == "") {
          EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "대표자명 항목을 확인 하세요.");
          // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
          return
        }
        if (this.editedItem.cTel == ""){
          EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "전화변호 항목을 확인 하세요.");
          // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
          return
        }
        if (this.editedItem.cFax != "" && !/^(?=.*[0-9]).{9,11}$/.test(this.editedItem.cFax)) {
          EventBus.$emit("onShowMsgBox","팩스번호 형식이 올바르지 않습니다.", "팩스번호는 '-'를 제외하고 숫자만 입력해주세요.");
          return;
        }
        if (this.editedItem.cHomePage != "" && !/^(http(s)?:\/\/)([a-z0-9\s.-]*)(.com$|.net$|.co.kr$)/.test(this.editedItem.cHomePage)) {
          EventBus.$emit("onShowMsgBox", "형식에 맞지 않은 값을 입력하셨습니다.", "홈페이지 항목을 확인 하세요.");
          // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
          return
        }
        if (this.editedItem.cAddr2 == ""){
          EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "상세주소 항목을 확인 하세요.");
          // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
          return
        }
      } else {
        if (this.editedItem.cCorpNmEng == ""){
          EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "회사명(영문) 항목을 확인 하세요.");
          // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
          return
        }
        if (this.editedItem.cCEO == "") {
          EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "대표자명 항목을 확인 하세요.");
          // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
          return
        }
        if (this.editedItem.cTel == ""){
          EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "전화변호 항목을 확인 하세요.");
          // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
          return
        }
        if (this.editedItem.cAddr1 == ""){
          EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "기본주소 항목을 확인 하세요.");
          // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
          return
        }
        if (!/^(?=.*[0-9]).{9,11}$/.test(this.editedItem.cFax)) {
          EventBus.$emit("onShowMsgBox","팩스번호 형식이 올바르지 않습니다.", "팩스번호는 '-'를 제외하고 숫자만 입력해주세요.");
          return;
        }
        if (this.editedItem.cHomePage != "" && !/^(http(s)?:\/\/)([a-z0-9\s.-]*)(.com$|.net$|.co.kr$)/.test(this.editedItem.cHomePage)) {
          EventBus.$emit("onShowMsgBox", "형식에 맞지 않은 값을 입력하셨습니다.", "홈페이지 항목을 확인 하세요.");
          // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
          return
        }
      }




      // if (this.editedItem.cHomePage == ""){
      //   EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "홈페이지 항목을 확인 하세요.");
      //   // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
      //   return
      // }

      // if (this.editedItem.cAddr1 == "") {
      //   EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "기본주소 항목을 확인 하세요.");
      //   // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
      //   return
      // }


      if (this.editedItem.cWork == ""){
        EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "{{$store.state.CustomInfo.SiteNm}} 관련 주요업무 항목을 확인 하세요.");
        // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
        return
      }

      if (this.editedItem.cChangeReason == ""){
        EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "변경 사유 항목을 확인 하세요.");
        // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
        return
      }

      if (this.editedItem.cChangeReason.length > 100){
        EventBus.$emit("onShowMsgBox", "변경 사유는 최대 100자만 입력 가능합니다.", "입력하신 내용이 띄어쓰기를 포함하여 100자가 넘는지 확인하여 주세요.");
        // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
        return
      }
      
      // if (this.NowSelFile == null && this.editedItem.cPath = ) {
      //   EventBus.$emit("onShowMsgBox", "사업자등록증이 누락 되었습니다.");
      //   // EventBus.$emit("onShowMsg",true, "필수입력 사항(회사명(한글))이 누락되었습니다. 확인하세요.")
      //   return
      // }

      // for (let i = 0; i < this.CorChargeInfo.length; i ++){
      //   if (this.CorChargeInfo[i].cCustomNm == ""){
      //     EventBus.$emit("onShowMsg",true, "이름이 누락된 관리자가 있습니다. 확인해 주시기를 바랍니다.")
      //     return
      //   }
      // }

      this.loading = true;

      if (this.NowSelFile != null) {
        var res = await this.bSendSvrFile();
        if (res.data.ResultCd == "00") {
          this.editedItem.cFileId = res.data.FileId;
          this.editedItem.cPath = res.data.Path;
        } else {
          EventBus.$emit("onShowMsg",true, "파일 저장에 실패하였습니다. 관리자에게 문의 바랍니다.");
          this.loading = false;
          return;
        }        
      }

      var posData = {
        BizCode : this.editedItem.cBizCode,
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
        CorpNmKor : this.editedItem.cCorpNmKor,
        CorpNmEng : this.editedItem.cCorpNmEng,
        CEO : this.editedItem.cCEO,
        Tel : this.editedItem.cTel,
        Fax : this.editedItem.cFax,
        HomePage : this.editedItem.cHomePage,
        FileId  : this.editedItem.cFileId,
        Zip : this.editedItem.cZip,
        Addr1 : this.editedItem.cAddr1,
        Addr2 : this.editedItem.cAddr2,
        Work : this.editedItem.cWork,
        Reason : this.editedItem.cChangeReason,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "SetCorpLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            this.editedItem.cChangeReason = "";
            this.CustomInfo.CorpNmKor = this.editedItem.cCorpNmKor
            this.loading = false;
            EventBus.$emit("onShowMsg",false,  "업체정보 정정신청이 완료 되었습니다.");
          } else if (res.data.ResultCd === "01" || res.data.ResultCd === "02") {
            EventBus.$emit("onShowMsgBox", "업체정보 정정 신청에 실패 하였습니다.", res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    // 관리자 목록에서 삭제하기
    DelManager() {
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
      };
      axios
        .post(process.env.VUE_APP_UIL_API + "DelManager", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            this.dialog = false;
            this.$router.push({name: 'MainBoard'})
            EventBus.$emit("onShowMsg",true,  "관리자 권한이 해지되어 홈 화면으로 이동합니다.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },      
  }
}
</script>

<style>
</style>